import "core-js/fn/object/assign.js";
import "core-js/fn/array/find.js";
import "core-js/fn/array/find-index.js";
import "core-js/fn/array/fill.js";
import "core-js/fn/array/includes.js";
import "core-js/fn/array/from.js";
import "core-js/fn/symbol";
